var API_DOMAIN = "https://mkgoldfinance.zentexus.com/api";
// var API_DOMAIN = "http://localhost/mk_gold_finance_api/api";
export default API_DOMAIN;
